export const buildCompanyStorageRequest = (
  companyId,
  assetType,
  fileName,
  operation = 'download'
) => {
  const id = Number(companyId)
  if (!Number.isInteger(id) || id <= 0 || !assetType || !fileName) {
    throw new Error('Company and file are required for company storage')
  }
  return {
    url: `${id}/${operation}-url`,
    payload: { assetType, fileName }
  }
}
